import type {
  ClusterModel,
  ContactModel,
  ProductDetailsContainerModel,
  ProductDetailsV2,
  ProductModel
} from "@/models/cluster";
import { getContact } from "@/services/contacts.service";
import type VueI18n from "vue-i18n";
import { ControlClusterModel } from "./ControlClusterModel";

export class PredictiveMaintenanceModel implements ProductDetailsContainerModel {
  constructor(private $i18n: VueI18n) {}
  get details(): ProductDetailsV2 {
    return {
      teaser: {
        text: this.$i18n.tc("predictiveMaintenance.details.teaser.text")
      },
      features: [
        {
          title: this.$i18n.tc("predictiveMaintenance.details.features.efficient.title"),
          text: this.$i18n.tc("predictiveMaintenance.details.features.efficient.text"),
          icon: require("@/assets/ui-assets/assets/icons/np_overview_2172952_000000.svg")
        },
        {
          title: this.$i18n.tc("predictiveMaintenance.details.features.downtimes.title"),
          text: this.$i18n.tc("predictiveMaintenance.details.features.downtimes.text"),
          icon: require("@/assets/ui-assets/assets/icons/np_OEMcontent_3233352_000000.svg")
        },
        {
          title: this.$i18n.tc("predictiveMaintenance.details.features.future.title"),
          text: this.$i18n.tc("predictiveMaintenance.details.features.future.text"),
          icon: require("@/assets/ui-assets/assets/icons/np_edit_3248033_000000.svg")
        }
      ],
      contactTeaser: this.$i18n.tc("predictiveMaintenance.details.contactTeaser"),
      explanation: {
        title: this.$i18n.tc("predictiveMaintenance.details.explanation.title"),
        text: this.$i18n.tc("predictiveMaintenance.details.explanation.text")
      },
      featureTeaser: this.$i18n.tc("predictiveMaintenance.details.featureTeaser")
    };
  }

  get cluster(): ClusterModel {
    return new ControlClusterModel(this.$i18n);
  }

  get product(): ProductModel {
    return {
      id: "predmain",
      title: this.$i18n.tc("predictiveMaintenance.product.title"),
      description: this.$i18n.tc("predictiveMaintenance.product.description"),
      image: require("@/assets/ui-assets/assets/design01/PredictiveMaintenance_einfarbig_RGB.svg"),
      imagehover: require("@/assets/ui-assets/assets/design01/PredictiveMaintenance_mehrfarbig_RGB.svg")
    };
  }

  get contacts(): ContactModel[] {
    return [getContact("svulp")];
  }
}
